import {useState, useEffect} from "react";
import "./Header.css";
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import {ReactComponent as MenuLightIcon} from "../../../assets/svg/menu_light.svg";
import {ReactComponent as MenuLightHoverIcon} from "../../../assets/svg/menu_light_hover.svg";
import {ReactComponent as MenuDarkIcon} from "../../../assets/svg/menu_dark.svg";
import {ReactComponent as MenuDarkHoverIcon} from "../../../assets/svg/menu_dark_hover.svg";
import {ReactComponent as CloseLightIcon} from "../../../assets/svg/x_light.svg";
import {ReactComponent as CloseDarkIcon} from "../../../assets/svg/x_dark.svg";
import {ReactComponent as NavButtonLightIcon} from "../../../assets/svg/nav-button-light-origin.svg";
import {ReactComponent as NavButtonDarkIcon} from "../../../assets/svg/nav-button-dark-origin.svg";


export default function Header({onNavClick, activeSection}) {
  const [active, setActive] = useState(activeSection);
  const [mobileOpen, setMobileOpen] = useState(false);


  const menu = [
    {key: "home", label: "Home"},
    {key: "about", label: "About Us"},
    {key: "products", label: "Products"},
    {key: "coverage", label: "Coverage"},
    {key: "team", label: "Our Team"},
    {key: "conferences", label: "Conferences"},
    {key: "contact", label: "Contact"},
  ];


  useEffect(() => {
    if (activeSection) {
      setActive(activeSection);
    }
  }, [activeSection]);


  useEffect(() => {
    if (mobileOpen) {
      document.documentElement.classList.add("menu-open");
      document.body.classList.add("menu-open");
    } else {
      document.documentElement.classList.remove("menu-open");
      document.body.classList.remove("menu-open");
    }

    return () => {
      document.documentElement.classList.remove("menu-open");
      document.body.classList.remove("menu-open");
    };
  }, [mobileOpen]);


  const handleClick = (key) => {
    setActive(key);
    onNavClick?.(key);
    setMobileOpen(false);
  };


  return (
    <header className="header">

      {/* ---- DESKTOP NAV ---- */}
      <nav
        className="nav desktop-nav"
        aria-label="Main navigation"
      >
        {menu.map((item) => (
          <button
            key={item.key}
            className={`nav-item${active === item.key ? " active" : ""}`}
            onClick={() => handleClick(item.key)}
            aria-current={active === item.key ? "page" : undefined}
          >
            {active === item.key && (
              <>
                <NavButtonLightIcon
                  className="nav-item-bg nav-item-bg-light"
                  preserveAspectRatio="none"
                  aria-hidden="true"
                  focusable="false"
                />
                <NavButtonDarkIcon
                  className="nav-item-bg nav-item-bg-dark"
                  preserveAspectRatio="none"
                  aria-hidden="true"
                  focusable="false"
                />
              </>
            )}
            {item.label}
          </button>
        ))}
      </nav>

      {/* ---- HAMBURGER ---- */}
      <button
        className="hamburger"
        onClick={() => setMobileOpen(true)}
        aria-label="Open menu"
        aria-expanded={mobileOpen}
      >
        <MenuLightIcon className="hamburger-icon hamburger-icon-light" aria-hidden="true" focusable="false"/>
        <MenuLightHoverIcon className="hamburger-icon hamburger-icon-light-hover" aria-hidden="true" focusable="false"/>
        <MenuDarkIcon className="hamburger-icon hamburger-icon-dark" aria-hidden="true" focusable="false"/>
        <MenuDarkHoverIcon className="hamburger-icon hamburger-icon-dark-hover" aria-hidden="true" focusable="false"/>
      </button>

      {/* ---- MOBILE MENU ---- */}
      <div
        className={`mobile-menu${mobileOpen ? " open" : ""}`}
        aria-hidden={!mobileOpen}
        role="dialog"
        aria-label="Mobile navigation"
      >
        <div className="mobile-menu-box">
          <button
            className="close"
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
          >
            <CloseLightIcon className="close-icon close-icon-light" aria-hidden="true" focusable="false"/>
            <CloseDarkIcon className="close-icon close-icon-dark" aria-hidden="true" focusable="false"/>
          </button>

          {menu.map((item) => (
            <button
              key={item.key}
              className={`mobile-item${active === item.key ? " active" : ""}`}
              onClick={() => handleClick(item.key)}
            >
              <NavButtonLightIcon
                className="mobile-item-bg mobile-item-bg-light"
                preserveAspectRatio="none"
                aria-hidden="true"
                focusable="false"
              />
              <NavButtonDarkIcon
                className="mobile-item-bg mobile-item-bg-dark"
                preserveAspectRatio="none"
                aria-hidden="true"
                focusable="false"
              />
              {item.label}
            </button>
          ))}
        </div>

      </div>

      <ThemeToggle/>
    </header>
  );
}
